module.exports = "    <div class=\"progress-value\" i18n=\"Progress percentage\">{{progress}}</div>\r\n    <div class=\"progress-messages\">{{progressMessage}}</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/splash/splash.component.html
// module id = 474
// module chunks = 0